<script>
import { BCarouselSlide } from "bootstrap-vue";

export default {
  extends: BCarouselSlide
};
</script>